/**
 * Environment configuration
 * Validates and exports environment variables with defaults
 */

export const env = {
  // API Configuration
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:3000',
  environment: (import.meta.env.VITE_ENV as string | undefined) ?? 'development',

  // Runtime Environment
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,

  // Observability (Highlight.io)
  observability: {
    enabled: import.meta.env.VITE_ENABLE_OBSERVABILITY === 'true',
    projectId: import.meta.env.VITE_HIGHLIGHT_PROJECT_ID as string | undefined,
  },

  // Analytics (PostHog)
  analytics: {
    enabled: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    apiKey: import.meta.env.VITE_POSTHOG_API_KEY as string | undefined,
    host: import.meta.env.VITE_POSTHOG_HOST as string | undefined,
  },

  // Feature Flags
  featureFlags: {
    enabled: import.meta.env.VITE_ENABLE_FEATURE_FLAGS === 'true',
  },
};
